import BaseAgencyScopeEntityDto from '@/models/Shared/BaseAgencyScopeEntityDto';
import ActivityType from './ActivityType';
import ActivityStatus from './ActivityStatus';
import ActivityDirection from './ActivityDirection';
import ActivityEntityType from './ActivityEntityType';
import ActivityCategoryDto from './ActivityCategoryDto';
import ActivityContactDto from './ActivityContactDto';
import EmailAttachmentDto from './EmailAttachmentDto';
import AgencyUserDto from '@/models/AgencyUsers/AgencyUserDto';
import BranchDto from '@/models/Branches/BranchDto';
import DeskDto from '@/models/Desks/DeskDto';
import CompanyDto from '@/models/Companies/CompanyDto';
import LocationDto from '@/models/Locations/LocationDto';
import ContactDto from '@/models/Contacts/ContactDto';
import WorkerDto from '@/models/Workers/WorkerDto';
import JobDto from '@/models/Jobs/JobDto';
import BookingDto from '@/models/Bookings/BookingDto';
import OpportunityDto from '@/models/Opportunities/OpportunityDto';

export default class ActivityDto extends BaseAgencyScopeEntityDto {
    // Type and status
    type: ActivityType = ActivityType.Note;
    status: ActivityStatus = ActivityStatus.Planned;

    // Branch and Desk (optional)
    branchId: string | null = null;
    branch: BranchDto | null = null;
    deskId: string | null = null;
    desk: DeskDto | null = null;

    // Category
    categoryId: string | null = null;
    category: ActivityCategoryDto | null = null;

    // Primary entity - what this activity is about
    primaryEntityType: ActivityEntityType = ActivityEntityType.Contact;
    primaryEntityId = '';
    primaryEntityName = '';

    // Related entity FKs (for cross-timeline queries, nullable)
    companyId: string | null = null;
    company: CompanyDto | null = null;
    locationId: string | null = null;
    location: LocationDto | null = null;
    contactId: string | null = null;
    contact: ContactDto | null = null;
    workerId: string | null = null;
    worker: WorkerDto | null = null;
    jobId: string | null = null;
    job: JobDto | null = null;
    bookingId: string | null = null;
    booking: BookingDto | null = null;
    campaignId: string | null = null;
    campaignContactId: string | null = null;
    opportunityId: string | null = null;
    opportunity: OpportunityDto | null = null;

    // Content
    subject = '';
    body = '';

    // Timing
    startAt: Date | null = null;
    endAt: Date | null = null;
    completedAt: Date | null = null;
    completedById: string | null = null;
    completedBy: AgencyUserDto | null = null;
    cancelledAt: Date | null = null;
    cancelledById: string | null = null;
    cancelledBy: AgencyUserDto | null = null;
    deletedAt: Date | null = null;
    deletedById: string | null = null;

    // Owner (agency user responsible for this activity)
    ownerId: string | null = null;
    owner: AgencyUserDto | null = null;

    // Task fields (type = 1)
    taskPriority: number | null = null;
    createdFromActivityId: string | null = null;
    nextActivityId: string | null = null;

    // Call fields (type = 3)
    phoneNumber = '';
    callOutcome: number | null = null;

    // Email fields (type = 5)
    emailSystemId: string | null = null;
    emailExternalMessageId: string | null = null;
    emailExternalThreadId = '';
    emailFromAddress = '';
    emailFromName = '';
    emailToAddresses: string[] = [];
    emailCcAddresses: string[] = [];
    emailBccAddresses: string[] = [];
    emailBodyStoragePath = '';
    emailHasAttachments = false;
    repliedToActivityId: string | null = null;

    // Direction (for Call and Email): 1=Outbound, 2=Inbound
    direction: ActivityDirection | null = null;

    // Meeting fields (type = 4)
    meetingIsOnline = false;
    meetingOnlineUrl = '';
    meetingLocation = '';

    // KPI exclusion (true for automated emails from campaigns/spec outs)
    excludeFromKPIs = false;

    // Related collections (loaded via preload)
    contacts: ActivityContactDto[] = [];
    attachments: EmailAttachmentDto[] = [];
}
